"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classes_1 = require("../classes");
class OrchestratorCompletedEvent extends classes_1.HistoryEvent {
    constructor(options) {
        super(classes_1.HistoryEventType.OrchestratorCompleted, options.eventId, options.isPlayed, options.timestamp);
    }
}
exports.OrchestratorCompletedEvent = OrchestratorCompletedEvent;
//# sourceMappingURL=orchestratorcompletedevent.js.map